import React, { useState } from 'react';
import { Badge } from '@/components/shared/Badge';
import { StatusDot } from '@/components/shared/StatusDot';
import type { StrategyGroup } from '@/types/bot';

interface StrategyGroupComponentProps {
  group: StrategyGroup;
  onStartBot: (id: string) => void;
  onStopBot: (id: string) => void;
}

export const StrategyGroupComponent: React.FC<StrategyGroupComponentProps> = ({
  group,
  onStartBot,
  onStopBot,
}) => {
  // Active groups start expanded, others collapsed
  const [expanded, setExpanded] = useState(group.status === 'active');
  const badgeVariant = group.status === 'active' ? 'success' : 'warning';
  const badgeLabel = group.status === 'active' ? 'ACTIVE' : 'PAUSED';

  // Sort bots: active first, then by name
  const sortedBots = [...group.bots].sort((a, b) => {
    if (a.status === 'active' && b.status !== 'active') return -1;
    if (a.status !== 'active' && b.status === 'active') return 1;
    return a.name.localeCompare(b.name);
  });

  return (
    <div className="strategy-group">
      <div
        className="strategy-group__header"
        onClick={() => setExpanded(!expanded)}
        style={{ cursor: 'pointer' }}
      >
        <span className="strategy-group__chevron">{expanded ? '\u25BC' : '\u25B6'}</span>
        <span className="strategy-group__name">{group.name}</span>
        <Badge variant={badgeVariant}>{badgeLabel}</Badge>
      </div>
      {expanded && (
        <ul className="strategy-group__bots">
          {sortedBots.map((bot) => {
            const isRunning = bot.status === 'active';
            return (
              <li key={bot.id} className="strategy-group__bot-row">
                <span className="strategy-group__bot-name">
                  <StatusDot color={isRunning ? 'green' : 'red'} />
                  {bot.name}
                  <span className="strategy-group__bot-market">[{bot.market}]</span>
                </span>
                <span className="strategy-group__bot-actions">
                  {isRunning ? (
                    <button
                      className="strategy-group__btn strategy-group__btn--stop"
                      onClick={(e) => { e.stopPropagation(); onStopBot(bot.id); }}
                    >
                      STOP
                    </button>
                  ) : (
                    <button
                      className="strategy-group__btn strategy-group__btn--start"
                      onClick={(e) => { e.stopPropagation(); onStartBot(bot.id); }}
                    >
                      START
                    </button>
                  )}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
